
import {
    Block,
    IBlockProcessor,
    VideoStudioBlock
} from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UltraBlockInterfaces';
import { UnsupportedBlockError } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UnsupportedBlockError';

export class VideoStudioBlockProcessor implements IBlockProcessor<VideoStudioBlock> {

    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
    }

    async process(block: Block): Promise<string> {
        throw new UnsupportedBlockError(`Video Studio blocks are not yet supported : ${ block.id}`);
    }
}
